import { useSelector } from 'react-redux';
import { isEqual } from 'lodash';
import { formValueSelector } from 'redux-form';

const useFormValues = ({ fieldsNames, formName }) => {
  const selector = formValueSelector(formName);
  return useSelector(state => {
    const formValues = fieldsNames.reduce((acc, k) => {
      acc[k] = selector(state, k);
      return acc;
    }, {});
    return formValues;
  }, isEqual)
};

export { useFormValues };
